export default {"src":"/_next/static/image/public/images/ic_radio_female.d434c16dc3d32d340c5dd339c5c10f91.svg","height":25,"width":24};